import React from 'react';
import {
  Container,
  Col,
  Row,
  Div,
} from '../../components/grid';
import {
  Heading1,
  Paragraph,
  LinkStyled,
  Bold,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="FAQ">
    <Container white itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
      <Row block>
        <Col xs={12}>
          <Row m0 innerShadow>
            <Col xs={12} padding="40px 15px" grey>
              <Row>
                <Col xs={12} md={6} offset={{ md: 3 }}>
                  <Heading1 fontSize="18px" itemprop="name">Hvad gør man, når fadøllet skummer for meget?</Heading1>
                  <hr />
                  <Paragraph>
                    <Bold>Svar:</Bold>
                  </Paragraph>
                  <Div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                    <Paragraph>Når fadøl skummer er det næsten altid fordi det ikke er koldt nok. Ofte er løsningen at tilslutte strømmen.</Paragraph>
                    <Paragraph>
                      Fejlen kan også være grater eller urenheder i slanger eller hane, men langt det mest almindelige er at det er køling der mangler.
                      For vandkølede anlæg vil manglende omrøring i vandtanken straks give skum problemer.
                      Check at vandtaken er fyldt og at der er både vand og is i den.
                      Check at vandet tanken bevæger sig (omrøring).
                      Se efter om ølle løber klart ud af hanen eller om det allerede er hvidt skum når det forlader hanen.
                      Hvis øllet løber klart fra hanen er det med stor sansynlighed glassene den er gal med.
                      Endelig kan kulsyretrykket stå forkert, men det er nu sjællendt det der er fejlen, trykket bør stå på mellem 2,5 og 3,0 bar både for højt og for lavt tryk kan få øllet til at skumme.
                      Selvfølgelig kan fejlen også ligge i selve øllet, skift til en anden fustage for at se om problemet er øllet. En sjat der har stået koldt i et stykke tid vil skumme.
                    </Paragraph>
                  </Div>
                  <hr />
                  <Paragraph textCenter>
                    <LinkStyled to="/faq/faq" title="Tilbage til FAQ oversigt">
                      Tilbage til FAQ oversigt
                    </LinkStyled>
                  </Paragraph>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
